<template>
  <div class="layout-px-spacing dash_1">
    <teleport to="#breadcrumb">
      <ul class="navbar-nav flex-row">
        <li>
          <div class="page-header">
            <nav class="breadcrumb-one" aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item active" aria-current="page"><span>{{ $t('Dashboard') }}</span></li>
              </ol>
            </nav>
          </div>
        </li>
      </ul>
    </teleport>

    <div class="row layout-top-spacing">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <div class="row widget-statistic">
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12 layout-spacing">
            <div class="widget">
              <div class="widget-heading">
                <div class="w-title">
                  <div class="w-icon icon-fill-primary">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="feather feather-box" data-v-02c2cbc4="">
                      <path
                        d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z">
                      </path>
                      <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                      <line x1="12" y1="22.08" x2="12" y2="12"></line>
                    </svg>
                  </div>
                  <div>
                    <p class="w-value">{{ mainCard.destination }}</p>
                    <h5>Destinasi</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12 layout-spacing">
            <div class="widget">
              <div class="widget-heading">
                <div class="w-title">
                  <div class="w-icon icon-fill-danger">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="feather feather-link">
                      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                    </svg>
                  </div>
                  <div>
                    <p class="w-value">{{ mainCard.typeDestination }}</p>
                    <h5>Tipe Destination</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12 layout-spacing">
            <div class="widget">
              <div class="widget-heading">
                <div class="w-title">
                  <div class="w-icon icon-fill-success">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="feather feather-star" data-v-02c2cbc4="">
                      <polygon
                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                      </polygon>
                    </svg>
                  </div>
                  <div>
                    <p class="w-value">{{ mainCard.event }}</p>
                    <h5>Event</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12 layout-spacing">
            <div class="widget">
              <div class="widget-heading">
                <div class="w-title">
                  <div class="w-icon icon-fill-info">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="feather feather-book" data-v-02c2cbc4="">
                      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                    </svg>
                  </div>
                  <div>
                    <p class="w-value">{{ mainCard.blog }}</p>
                    <h5>Artikel</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
        <div class="widget widget-recent-orders">
          <div class="widget-heading">
            <h5>Artikel Terbaru</h5>
          </div>
          <div class="widget-content table-responsive">
            <table role="table" aria-busy="false" aria-colcount="5" class="table table-bordered" id="__BVID__415">
              <thead role="rowgroup">
                <tr role="row">
                  <th width="50px" role="columnheader" scope="col" class="text-black text-center">
                    <div>&nbsp;</div>
                  </th>
                  <th width="55%" role="columnheader" scope="col" class="text-black text-center">
                    <div>{{ $t('Title') }}</div>
                  </th>
                  <th role="columnheader" scope="col" class="text-black text-center">
                    <div>{{ $t('Created By') }}</div>
                  </th>
                  <th role="columnheader" scope="col" class="text-black text-center">
                    <div>{{ $t('Created At') }}</div>
                  </th>
                </tr>
              </thead>
              <tbody role="rowgroup">
                <tr v-for="item in listBlog" :key="item.blog_id" role="row">
                  <td role="cell" class="text-center" style="width:20px;">
                    <template v-if="item.image?.file_id">
                      <img class="rounded" style="height:30px;" :src="item.image?.file_url" />
                    </template>
                    <template v-else>
                      <i class="fa fa-3x fa-image"></i>
                    </template>
                  </td>
                  <td role="cell">{{ item.title }}</td>
                  <td role="cell">{{ item.created_by }}</td>
                  <td role="cell">{{ item.created_at }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 layout-spacing">
        <div class="widget widget-recent-activity">
          <div class="widget-heading">
            <h5>Event Terbaru</h5>
          </div>
          <div class="widget-content">
            <perfect-scrollbar class="timeline-line">
              <div class="item-timeline timeline-dark" v-for="item in listEvent" :key="item.event_id">
                <div class="badge badge-dark"></div>
                <div class="t-text">
                  <p>{{ item.name }}</p>
                  <p class="t-time">{{ item.date }}</p>
                </div>
              </div>
            </perfect-scrollbar>
          </div>
        </div>
      </div>

      <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-12 layout-spacing">
        <div class="widget widget-top-selling-products">
          <div class="widget-heading">
            <h5>Pengumuman</h5>
          </div>

          <div class="widget-content table-responsive">
            <table role="table" aria-busy="false" aria-colcount="5" class="table table-bordered" id="__BVID__415">
              <thead role="rowgroup">
                <tr role="row">
                  <th width="50px" role="columnheader" scope="col" class="text-black text-center">
                    <div>&nbsp;</div>
                  </th>
                  <th role="columnheader" scope="col" class="text-black text-center">
                    <div>{{ $t('Title') }}</div>
                  </th>
                  <th role="columnheader" scope="col" class="text-black text-center">
                    <div>{{ $t('Created By') }}</div>
                  </th>
                  <th role="columnheader" scope="col" class="text-black text-center">
                    <div>{{ $t('Created At') }}</div>
                  </th>
                </tr>
              </thead>
              <tbody role="rowgroup">
                <tr v-for="item in listAnnouncement" :key="item.ann_id" role="row">
                  <td role="cell" class="text-center" style="width:20px;">
                    <template v-if="item.image?.file_id">
                      <img class="rounded" style="height:30px;" :src="item.image?.file_url" />
                    </template>
                    <template v-else>
                      <i class="fa fa-3x fa-image"></i>
                    </template>
                  </td>
                  <td role="cell">{{ item.desc }}</td>
                  <td role="cell">{{ item.created_by }}</td>
                  <td role="cell">{{ item.created_at }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useDashboardStore } from '@/store/dashboardStore';
import '@/assets/sass/widgets/widgets.scss';
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import ApexChart from 'vue3-apexcharts';

// init
const dashboardStore = useDashboardStore();
dashboardStore.getData();
const { mainCard, listBlog, listEvent, listAnnouncement } = storeToRefs(dashboardStore);

</script>
